export enum DisinfectionInstructions {
    Instruction1 = 'Instruction 1',
    Instruction2 = 'Instruction 2',
    Instruction3 = 'Instruction 3',
    Instruction4 = 'Instruction 4'
  }